export default function(){
    (function($) {

        //copy item content to clipboard on click
        $('.clipboard').click(function () {
            $(this).addClass("animate").delay(100).queue(function(next) {
                $(this).removeClass("animate");
                next();
            });
            let str = $(this).text();
            const el = document.createElement('textarea');
            el.value = str;
            el.setAttribute('readonly', '');
            el.style.position = 'absolute';
            el.style.left = '-9999px';
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
        })


    })(jQuery);
}